import Api from "../axios";

import { PaymentProcessorEnum } from "../models/payment-processor.enum";

export interface PaymentSettingsResult {
  processors: {
    wompi: { enabled: boolean };
    blockbee: { enabled: boolean };
  };
  defaultProcessor: PaymentProcessorEnum;
  envStatus?: {
    blockbeeConfigured: boolean;
    wompiConfigured: boolean;
  };
}

export async function getPaymentSettingsReq(): Promise<PaymentSettingsResult> {
  const api = Api.getInstance();
  const response = await api.get({ path: "payment-settings" });
  if (response.error == null) {
    return response.result;
  }
  throw response.error;
}

export async function updatePaymentSettingsReq(data: {
  processors?: {
    wompi?: { enabled?: boolean };
    blockbee?: { enabled?: boolean };
  };
  defaultProcessor?: PaymentProcessorEnum;
}): Promise<PaymentSettingsResult> {
  const api = Api.getInstance();
  const response = await api.put({ path: "payment-settings", data });
  if (response.error == null) {
    return response.result;
  }
  throw response.error;
}
